import { DependencyList, useRef } from 'react'
import isEqual from 'lodash/isEqual'

export function useDeepCompareMemoize(value: DependencyList) {
  const ref = useRef<DependencyList>([])

  if (!isEqual(value, ref.current)) {
    ref.current = value
  }

  return ref.current
}
